// app/blog/[slug]/not-found.js
'use client'
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
    const router = useRouter();

    useEffect(() => {
        router.replace('/');
    }, [router]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <p>Blog not found. Redirecting to home page...</p>
            </div>
        </div>
    );
}